<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="5" y="10.5" width="4" height="2" rx=".5"/><path d="M21 11v-1a3.5 3.5 0 00-2-3.15V5.5A1.5 1.5 0 0017.5 4h-14A1.5 1.5 0 002 5.5v11A1.5 1.5 0 003.5 18H13v1a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1zm-3.5-2.5A1.5 1.5 0 0119 10v1h-3v-1a1.5 1.5 0 011.5-1.5zM17 6v.55A3.48 3.48 0 0014.64 8H4V6zM4 16V9h10.16a3.67 3.67 0 00-.16 1v1a1 1 0 00-1 1v2h-2.5a.5.5 0 000 1H13v1zm16 2h-5v-5h5z"/><path d="M8.5 14h-3a.5.5 0 000 1h3a.5.5 0 000-1zM17 15.85v.65a.5.5 0 001 0v-.65a1 1 0 10-1 0z"/></svg>